import type { TreatmentType } from '@/lib/apis/treatments'
import {
  ED_LANDING_PAGE,
  MHL_LANDING_PAGE,
  PE_LANDING_PAGE,
  WL_LANDING_PAGE,
} from '@/lib/links'

type QuizErrorLinks = {
  alreadyCompletedQuiz: string
  rejectedQuiz: string
}

export const EDQuizErrorLinks = {
  alreadyCompletedQuiz: `${ED_LANDING_PAGE}/quiz/completed-error`,
  rejectedQuiz: `${ED_LANDING_PAGE}/quiz/rejected-error`,
}

export const PEQuizErrorLinks = {
  alreadyCompletedQuiz: `${PE_LANDING_PAGE}/quiz/completed-error`,
  rejectedQuiz: `${PE_LANDING_PAGE}/quiz/rejected-error`,
}

export const MHLQuizErrorLinks = {
  alreadyCompletedQuiz: `${MHL_LANDING_PAGE}/quiz/completed-error`,
  rejectedQuiz: `${MHL_LANDING_PAGE}/quiz/rejected-error`,
}

export const WLQuizErrorLinks = {
  alreadyCompletedQuiz: `${WL_LANDING_PAGE}/quiz/completed-error`,
  rejectedQuiz: `${WL_LANDING_PAGE}/quiz/rejected-error`,
}

export const QuizErrorLinksByTreatment = {
  ed: EDQuizErrorLinks,
  pe: PEQuizErrorLinks,
  mhl: MHLQuizErrorLinks,
  wl: WLQuizErrorLinks,
} satisfies Record<TreatmentType, QuizErrorLinks>
